<lib-sidenav-container class="tree">
    <lib-sidenav
        [items]="service.tree"
        [disableCollapseMode]="true"
        (itemClicked)="service.handleItemClicked($event)"
        (groupClicked)="service.handleGroupClicked($event)"
    >
    </lib-sidenav>
</lib-sidenav-container>
